import { render } from "./IconLocation.vue?vue&type=template&id=3f99543f"
import script from "./IconLocation.vue?vue&type=script&lang=ts"
export * from "./IconLocation.vue?vue&type=script&lang=ts"
script.render = render

export default script